(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ergosed-why-product"] && !Shopify.designMode) return;
  try {
    

  (() => {

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;



    const reveal = (root) => {

      const sections = root.querySelectorAll('[data-ergosed-why]');

      if (reducedMotion || !('IntersectionObserver' in window)) {

        sections.forEach((section) => section.classList.add('is-in-view'));

        return;

      }



      const observer = new IntersectionObserver((entries) => {

        entries.forEach((entry) => {

          if (entry.isIntersecting) {

            entry.target.classList.add('is-in-view');

            observer.unobserve(entry.target);

          }

        });

      }, { threshold: 0.12 });



      sections.forEach((section) => observer.observe(section));

    };



    reveal(document);



    document.addEventListener('shopify:section:load', (event) => reveal(event.target));



    document.addEventListener('click', (event) => {

      const button = event.target.closest('[data-ergosed-buy-jump]');

      if (!button) return;



      const target = document.querySelector('.product-form__submit, product-form button[name="add"], button[name="add"]') || document.querySelector('#MainContent');

      if (!target) return;



      event.preventDefault();

      target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });

      if (target.matches('button')) target.focus({ preventScroll: true });

    });

  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    const collection = document.querySelector('collection-component');

    if (!collection) return;

    /* =====================================================
       PREVODI GUMBA
       ===================================================== */

    const collectionLocale =
      collection.dataset.collectionLocale || 'en';

    const languageCode =
      collectionLocale.split('-')[0];

    const collectionButtonLabels = {
      sl: 'Izberi možnosti',
      en: 'Choose options',
      de: 'Optionen auswählen',
      it: 'Scegli le opzioni'
    };

    const collectionButtonText =
      collectionButtonLabels[collectionLocale] ||
      collectionButtonLabels[languageCode] ||
      'Choose options';

    /* =====================================================
       PRODUCT CARDS
       ===================================================== */

    const setupCollectionCards = (root = collection) => {
      const cards = root.querySelectorAll('.product-card');

      cards.forEach((card) => {
        const productLink =
          card.querySelector('.product-card__link');

        const originalAddToCart =
          card.querySelector('.add-to-cart-button');

        const cardContent =
          card.querySelector('.product-grid__card');

        if (!productLink || !cardContent) return;

        /* ---------------------------------------------------
           SKRIJ PRAVI ADD TO CART
           --------------------------------------------------- */

        if (originalAddToCart) {
          const hideTarget =
            originalAddToCart.closest('form') ||
            originalAddToCart.parentElement;

          if (hideTarget) {
            hideTarget.classList.add(
              'collection-add-to-cart-hidden'
            );
          }
        }

        /* ---------------------------------------------------
           SKRIJ QUICK ADD ČEZ SLIKO
           --------------------------------------------------- */

        const quickAdd = card.querySelector(
          'quick-add-component, .quick-add'
        );

        if (quickAdd) {
          quickAdd.classList.add(
            'collection-quick-add-hidden'
          );
        }

        /* ---------------------------------------------------
           PREPREČI PODVAJANJE NOVEGA GUMBA
           --------------------------------------------------- */

        const existingButton =
          cardContent.querySelector(
            '.collection-product-button'
          );

        if (existingButton) {
          // This runs from a MutationObserver that watches childList changes.
          // Replacing textContent with the same value still creates a childList
          // mutation, which would trigger the observer again indefinitely.
          if (existingButton.textContent !== collectionButtonText) {
            existingButton.textContent = collectionButtonText;
          }

          if (existingButton.getAttribute('aria-label') !== collectionButtonText) {
            existingButton.setAttribute('aria-label', collectionButtonText);
          }

          return;
        }

        const productUrl =
          productLink.getAttribute('href');

        if (!productUrl) return;

        /* ---------------------------------------------------
           USTVARI GUMB ZA PRODUCT PAGE
           --------------------------------------------------- */

        const productButton =
          document.createElement('a');

        productButton.className =
          'collection-product-button';

        productButton.href = productUrl;

        productButton.textContent =
          collectionButtonText;

        productButton.setAttribute(
          'aria-label',
          collectionButtonText
        );

        cardContent.appendChild(productButton);
      });
    };

    /* Prvi zagon */
    setupCollectionCards();

    /* Deluje tudi pri:
       - infinite scrollu
       - filtriranju
       - sortiranju */
    const observer = new MutationObserver(() => {
      setupCollectionCards();
    });

    observer.observe(collection, {
      childList: true,
      subtree: true
    });
  });

  } catch(e) { console.error(e); }
})();
})();
